<dw-ui-dialog-box
  [title]="dialogBoxTitle"
  [saveDisabled]="!canSave()"
  [saveLabel]="'Doc::SupplierPreparation:Validate' | abpLocalization"
  (saveFn)="save()"
>
  <div class="preparation-grid-section">
    <h6 class="section-title">{{ 'Doc::SupplierPreparation:LinesToPrepare' | abpLocalization }}</h6>

    @if (isLoading) {
      <div class="text-center py-4">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    } @else {
      <div class="grid-wrapper">
        <dw-grid-ag-grid
          #agGrid
          [inputRowData]="lines"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [hasPagination]="false"
          [hideFilter]="true"
          [hidePanelColumn]="true"
          [autoSize]="false"
          [isRowSelectable]="isRowSelectable"
          (selectedRowsChange)="onSelectionChanged($event)"
        ></dw-grid-ag-grid>
      </div>
    }
  </div>

  <div class="preparation-info-section mt-4">
    <h6 class="section-title">{{ 'Doc::SupplierPreparation:AdditionalInfo' | abpLocalization }}</h6>

    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="dayBookId" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::DayBook' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="dayBookId"
            formControlName="dayBookId"
            bindLabel="code"
            bindValue="id"
            [items]="daybooks"
          >
          </ng-select>
        </div>

        <div class="col-md-6 mb-3">
          <label for="statusId" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::SupplierPreparation:PreparationStatus' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="statusId"
            formControlName="statusId"
            bindLabel="name.current"
            bindValue="uniqueCode"
            [items]="statusOptions"
          >
          </ng-select>
        </div>
      </div>

      @if (form.get('statusId')?.value === SupplierPreparationStatus.Draft) {
        <div class="row mb-3">
          <div class="col-12">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="modeNew"
                name="preparationMode"
                [checked]="preparationMode === 'new'"
                (change)="onPreparationModeChange('new')"
              />
              <label class="form-check-label" for="modeNew">
                {{ 'Doc::SupplierPreparation:NewPreparation' | abpLocalization }}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="modeExisting"
                name="preparationMode"
                [checked]="preparationMode === 'existing'"
                [disabled]="existingPreparations.length === 0"
                (change)="onPreparationModeChange('existing')"
              />
              <label class="form-check-label" for="modeExisting">
                {{ 'Doc::SupplierPreparation:AddToExisting' | abpLocalization }}
              </label>
            </div>
          </div>
        </div>

        @if (preparationMode === 'existing') {
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="existingPreparation" class="form-label text-primary" dwInputRequired>
                {{ 'Doc::SupplierPreparation:ExistingPreparation' | abpLocalization }}
              </label>
              <ng-select
                class="form-control"
                id="existingPreparation"
                bindLabel="displayNumber"
                [items]="existingPreparations"
                [ngModel]="selectedExistingPreparation"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onExistingPreparationChange($event)"
              >
              </ng-select>
            </div>
          </div>
        }
      }

      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="reference" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::SupplierPreparation:Reference' | abpLocalization }}
          </label>
          <input type="text" class="form-control" id="reference" formControlName="reference" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label for="receivingInstruction" class="form-label text-primary">
            {{ 'Doc::SupplierPreparation:ReceivingInstruction' | abpLocalization }}
          </label>
          <textarea
            class="form-control"
            id="receivingInstruction"
            formControlName="receivingInstruction"
            rows="3"
          ></textarea>
        </div>
      </div>
    </form>
  </div>
</dw-ui-dialog-box>
